import PonduranceSvgIcon from './PonduranceSvgIcon';

export default PonduranceSvgIcon;
